// Seções previstas no mockup e ainda sem API.
//
// Aparecem no menu em vez de sumir: quem opera precisa saber que o recurso
// está previsto, e a alternativa é procurar onde ele está. Cada uma diz o que
// FARIA e quando — dizer "em breve" e nada mais não ajuda ninguém a planejar.

import { AindaNao } from "./comuns";

export function Relay() {
  return (
    <AindaNao
      titulo="Relay de saída"
      oQueFaria="Encaminhar o envio por um provedor externo, para os casos em que a porta 25 do servidor não é aceita pelo destino — IP residencial, faixa com reputação ruim, ou operadora que bloqueia."
      quando="Em avaliação."
    />
  );
}


export function Backups() {
  return (
    <AindaNao
      titulo="Backups"
      oQueFaria="Agendar, acompanhar e RESTAURAR — inclusive testar a restauração, que é a única forma de saber que o backup presta."
      quando="Fase 6: o PROMPTS.md põe backup e restauração junto do empacotamento."
    />
  );
}

export function Licenca() {
  return (
    <AindaNao
      titulo="Licença"
      oQueFaria="Mostrar a licença instalada, os limites de domínios e caixas, e a validade."
      quando="Fase 6. E há uma pendência jurídica antes: a consulta sobre redistribuição dos componentes, com o material em docs/licencas.md."
    />
  );
}
